module.exports = __webpack_public_path__ + "static/media/2_en.d9fc8e95.png";